import moment from "moment";
const timeDisplay = (time: string) => {
  return moment(time).format("MMM Do YYYY [@] HH:mm");
};

export default timeDisplay;
